import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";

import Permission from "Components/Common/Permission";
import { getIndividualAgencies } from "common/services/individuals.service";
import { Link } from "react-router-dom";
import Activity from "./Activity";

const Details = ({ individual }: { individual: any }) => {
  const [agencies, setAgencies] = useState<any>([]);
  useEffect(() => {
    const fetchAgencies = async () => {
      const response = await getIndividualAgencies(individual?.id);
      setAgencies(response?.data);
    };
    if (individual?.id) {
      fetchAgencies();
    }
  }, [individual]);

  return (
    <React.Fragment>
      <Col xxl={9}>
        <Card className="h-100">
          <CardHeader className="d-flex align-items-center border-bottom-dashed">
            <div className="text-muted flex-grow-1 d-flex align-items-center">
              <h6 className="mb-0 fw-semibold text-uppercase">Bio Data</h6>
            </div>
            <div className="flex-shrink-0 d-flex align-items-center">
              <Permission resource={"person"} action={"update"}>
                <Link
                  to="#"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  className="link-primary link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover me-3"
                >
                  <i className="ri-pencil-line"></i> Edit
                </Link>
              </Permission>
            </div>
          </CardHeader>
          <CardBody className="p-4">
            <Row>
              <Col md={12}>
                <div className="fs-13">
                  <Row className="px-1 mb-2">
                    <Col lg={3} sm={3}>
                      <div className="fw-medium">Full Name:</div>
                    </Col>
                    <Col lg={9} sm={9}>
                      {individual?.fullName || ""}
                    </Col>
                  </Row>

                  <Row className="px-1 mb-2">
                    <Col lg={3} sm={3}>
                      <div className="fw-medium">Gender:</div>
                    </Col>
                    <Col lg={9} sm={9}>
                      {individual?.gender || "Not Provided"}
                    </Col>
                  </Row>
                  <Row className="px-1 mb-2">
                    <Col lg={3} sm={3}>
                      <div className="fw-medium">Passport Or ID Number:</div>
                    </Col>
                    <Col lg={9} sm={9}>
                      {individual?.passportOrIdNumber || "Not Provided"}
                    </Col>
                  </Row>
                  <Row className="px-1 mb-2">
                    <Col lg={3} sm={3}>
                      <div className="fw-medium">Email Address:</div>
                    </Col>
                    <Col lg={9} sm={9}>
                      {individual?.emailAddress || "Not Provided"}
                    </Col>
                  </Row>
                  <Row className="px-1 mb-2">
                    <Col lg={3} sm={3}>
                      <div className="fw-medium">Phone Number:</div>
                    </Col>
                    <Col lg={9} sm={9}>
                      {individual?.phoneNumber || "Not Provided"}
                    </Col>
                  </Row>
                  <Row className="px-1 mb-2 mt-3">
                    <Col lg={3} sm={3}>
                      <div className="fw-medium">Positions Funded By:</div>
                    </Col>
                    <Col lg={9} sm={9}>
                      {agencies.length > 0 && (
                        <Row className="mt-0">
                          <div className="col-md">
                            <div className="hstack gap-2 flex-wrap">
                              {agencies.map((agency: any) => {
                                if (agency?.hasActiveContract) {
                                  return (
                                    <span
                                      key={agency.id}
                                      className="badge border border-primary text-white bg-primary fs-12"
                                    >
                                      {agency?.name}
                                    </span>
                                  );
                                }
                                return (
                                  <span
                                    key={agency.id}
                                    className="badge border border-primary text-primary fs-12"
                                  >
                                    {agency?.name}
                                  </span>
                                );
                              })}
                            </div>
                          </div>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
        {/* <Payments /> */}
      </Col>
      <Col xxl={3}>
        <Activity individual={individual} />
      </Col>
    </React.Fragment>
  );
};

export default Details;
